import { Badge, BadgeProps, styled } from '@mui/material';

const BADGE_HEIGHT = '15px';

export const BadgeStyled = styled(Badge)<BadgeProps>(() => ({
  '&.MuiBadge-root .MuiBadge-badge': {
    fontWeight: 600,
    fontSize: '0.7rem',
    height: BADGE_HEIGHT,
    lineHeight: BADGE_HEIGHT,
    minWidth: '15px',
    padding: `0 3px`,
  },
}));
